// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectRoofStructureQueryResult, selectRoofStructuresPageLoading, selectRoofStructuresShowInitWaitingMessage} from '../_selectors/roof-structure.selectors';

export class RoofStructuresDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectRoofStructuresPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectRoofStructuresShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectRoofStructureQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
